import { Component } from '@angular/core';
import {OverlayRef} from "@angular/cdk/overlay";
import {ModalConfig} from "../../../models/modal-config";
import {ProjectPhotoService} from "../../../services/project-photo.service";
import {ProjectPhoto} from "../../../models/project-photo";
import {SharedModule} from "../../../shared/shared.module";
import {ModalTitleComponent} from "../../ui/modal-title/modal-title.component";
import {ModalBodyComponent} from "../../ui/modal-body/modal-body.component";
import {ModalComponent} from "../../ui/modal/modal.component";
import {ModalFooterComponent} from "../../ui/modal-footer/modal-footer.component";
import {ButtonComponent} from "../../ui/button/button.component";
import {firstValueFrom} from "rxjs";
import {AsyncPipe, NgForOf} from "@angular/common";
import {LoaderComponent} from "../../ui/loader/loader.component";
import {ProjectPhotoPreviewPipe} from "../../../pipes/project-photo-preview.pipe";

@Component({
  selector: 'app-project-photo-view-modal',
  standalone: true,
  imports: [
    SharedModule,
    ModalTitleComponent,
    ModalBodyComponent,
    ModalComponent,
    ModalFooterComponent,
    ButtonComponent,
    AsyncPipe,
    LoaderComponent,
    NgForOf,
    ProjectPhotoPreviewPipe
  ],
  templateUrl: './project-photo-view-modal.component.html',
  styleUrl: './project-photo-view-modal.component.scss'
})
export class ProjectPhotoViewModalComponent {
  public projectPhoto: ProjectPhoto;
  loading = false;

  constructor(private overlayRef: OverlayRef, private modalConfig: ModalConfig, private projectPhotoService: ProjectPhotoService) {
    this.projectPhoto = this.modalConfig.data.projectPhoto;
  }

  async download() {
    if (this.loading || !this.projectPhoto) {
      return;
    }

    this.loading = true;

    try {
      const blob = await firstValueFrom(this.projectPhotoService.download(this.projectPhoto));

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;

      const originalFilename = this.projectPhoto!.filename;
      const takeExtension = originalFilename.split('.').pop() ?? '';
      const extension = takeExtension.split('-')[0];

      a.download = 'project-photo-' + this.projectPhoto!.id + '.' + extension;

      a.click();
      window.URL.revokeObjectURL(url);

      this.loading = false;
    } catch (e) {
      console.error(e);
    }
  }

  close() {
    this.overlayRef.dispose();
  }
}
